import { render, staticRenderFns } from "./MarketPercentage.vue?vue&type=template&id=c660efca"
import script from "./MarketPercentage.vue?vue&type=script&lang=js"
export * from "./MarketPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports